import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e4) { throw _e4; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e5) { didErr = true; err = _e5; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var De = Object.defineProperty,
    Te = Object.defineProperties;
var Fe = Object.getOwnPropertyDescriptors;
var ne = Object.getOwnPropertySymbols;
var Le = Object.prototype.hasOwnProperty,
    We = Object.prototype.propertyIsEnumerable;

var se = function se(e, r, t) {
  return r in e ? De(e, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[r] = t;
},
    V = function V(e, r) {
  for (var t in r || (r = {})) {
    Le.call(r, t) && se(e, t, r[t]);
  }

  if (ne) {
    var _iterator = _createForOfIteratorHelper(ne(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        We.call(r, t) && se(e, t, r[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    le = function le(e, r) {
  return Te(e, Fe(r));
};

function Y(e) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      r = _ref.insertAt;

  if (!e || typeof document == "undefined") return;
  var t = document.head || document.getElementsByTagName("head")[0],
      o = document.createElement("style");
  o.type = "text/css", r === "top" && t.firstChild ? t.insertBefore(o, t.firstChild) : t.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
}

Y(".rmsc{--rmsc-main: #4285f4;--rmsc-hover: #f1f3f5;--rmsc-selected: #e2e6ea;--rmsc-border: #ccc;--rmsc-gray: #aaa;--rmsc-bg: #fff;--rmsc-p: 10px;--rmsc-radius: 4px;--rmsc-h: 38px}.rmsc *{box-sizing:border-box;transition:all .2s ease}.rmsc .gray{color:var(--rmsc-gray)}.rmsc .dropdown-content{position:absolute;z-index:1;top:100%;width:100%;padding-top:8px}.rmsc .dropdown-content .panel-content{overflow:hidden;border-radius:var(--rmsc-radius);background:var(--rmsc-bg);box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a}.rmsc .dropdown-container{position:relative;outline:0;background-color:var(--rmsc-bg);border:1px solid var(--rmsc-border);border-radius:var(--rmsc-radius)}.rmsc .dropdown-container[aria-disabled=true]:focus-within{box-shadow:var(--rmsc-gray) 0 0 0 1px;border-color:var(--rmsc-gray)}.rmsc .dropdown-container:focus-within{box-shadow:var(--rmsc-main) 0 0 0 1px;border-color:var(--rmsc-main)}.rmsc .dropdown-heading{position:relative;padding:0 var(--rmsc-p);display:flex;align-items:center;width:100%;height:var(--rmsc-h);cursor:default;outline:0}.rmsc .dropdown-heading .dropdown-heading-value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}.rmsc .clear-selected-button{cursor:pointer;background:none;border:0;padding:0;display:flex}.rmsc .options{max-height:260px;overflow-y:auto;margin:0;padding-left:0}.rmsc .options li{list-style:none;margin:0}.rmsc .select-item{box-sizing:border-box;cursor:pointer;display:block;padding:var(--rmsc-p);outline:0}.rmsc .select-item:hover,.rmsc .select-item:focus{background:var(--rmsc-hover)}.rmsc .select-item.selected{background:var(--rmsc-selected)}.rmsc .no-options{padding:var(--rmsc-p);text-align:center;color:var(--rmsc-gray)}.rmsc .search{width:100%;position:relative;border-bottom:1px solid var(--rmsc-border)}.rmsc .search input{background:none;height:var(--rmsc-h);padding:0 var(--rmsc-p);width:100%;outline:0;border:0}.rmsc .search-clear-button{cursor:pointer;position:absolute;top:0;right:0;bottom:0;background:none;border:0;padding:0 calc(var(--rmsc-p) / 2)}.rmsc .search-clear-button [hidden]{display:none}.rmsc .item-renderer{display:flex;align-items:baseline}.rmsc .item-renderer input{margin:0 5px 0 0}.rmsc .item-renderer.disabled{opacity:.5}.rmsc .spinner{animation:rotate 2s linear infinite}.rmsc .spinner .path{stroke:var(--rmsc-border);stroke-width:4px;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}\n");
import ee from "react";
import q, { useEffect as Ke, useState as _e } from "react";

var Re = {
  allItemsAreSelected: "All items are selected.",
  clearSearch: "Clear Search",
  clearSelected: "Clear Selected",
  noOptions: "No options",
  search: "Search",
  selectAll: "Select All",
  selectAllFiltered: "Select All (Filtered)",
  selectSomeItems: "Select...",
  create: "Create"
},
    He = {
  value: [],
  hasSelectAll: !0,
  className: "multi-select",
  debounceDuration: 200,
  options: []
},
    ae = q.createContext({}),
    ie = function ie(_ref2) {
  var e = _ref2.props,
      r = _ref2.children;

  var _e2 = _e(e.options),
      _e3 = _slicedToArray(_e2, 2),
      t = _e3[0],
      o = _e3[1],
      n = function n(s) {
    var a;
    return ((a = e.overrideStrings) == null ? void 0 : a[s]) || Re[s];
  };

  return Ke(function () {
    o(e.options);
  }, [e.options]), q.createElement(ae.Provider, {
    value: le(V(V({
      t: n
    }, He), e), {
      options: t,
      setOptions: o
    })
  }, r);
},
    k = function k() {
  return q.useContext(ae);
};

import S, { useEffect as et, useRef as tt, useState as X } from "react";
import { useEffect as Ue, useRef as Be } from "react";

function ce(e, r) {
  var t = Be(!1);
  Ue(function () {
    t.current ? e() : t.current = !0;
  }, r);
}

import { useCallback as $e, useEffect as de, useMemo as je, useRef as Ve } from "react";
var Ye = {
  when: !0,
  eventTypes: ["keydown"]
};

function P(e, r, t) {
  var o = je(function () {
    return Array.isArray(e) ? e : [e];
  }, [e]),
      n = Object.assign({}, Ye, t),
      s = n.when,
      a = n.eventTypes,
      b = Ve(r),
      i = n.target;
  de(function () {
    b.current = r;
  });
  var m = $e(function (c) {
    o.some(function (d) {
      return c.key === d || c.code === d;
    }) && b.current(c);
  }, [o]);
  de(function () {
    if (s && typeof window != "undefined") {
      var c = i ? i.current : window;
      return a.forEach(function (d) {
        c && c.addEventListener(d, m);
      }), function () {
        a.forEach(function (d) {
          c && c.removeEventListener(d, m);
        });
      };
    }
  }, [s, a, o, i, r]);
}

var h = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  ENTER: "Enter",
  ESCAPE: "Escape",
  SPACE: "Space"
};
import y, { useCallback as Xe, useEffect as be, useMemo as ve, useRef as xe, useState as H } from "react";

var pe = function pe(e, r) {
  var t;
  return function () {
    for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
      o[_key] = arguments[_key];
    }

    clearTimeout(t), t = setTimeout(function () {
      e.apply(null, o);
    }, r);
  };
};

function me(e, r, t) {
  if (!r) return e;
  var o = ue(r, t);
  return e.filter(function (_ref3) {
    var n = _ref3.label,
        s = _ref3.value;
    return n != null && s != null;
  }).map(function (n) {
    return {
      option: n,
      score: qe(ue(n.label, t), o)
    };
  }).filter(function (n) {
    return n.score >= Math.max(o.length - 2, o.length);
  }).sort(function (n, s) {
    return s.score - n.score;
  }).map(function (n) {
    return n.option;
  });
}

function qe(e, r) {
  var _ref4, _ref5;

  var t = e.length,
      o = r.length,
      n = [];
  if (!t || !o) return 0;
  if (t < o && ((_ref4 = [r, e], e = _ref4[0], r = _ref4[1], _ref4), (_ref5 = [o, t], t = _ref5[0], o = _ref5[1], _ref5)), e.indexOf(r) !== -1) return o + 1 / t;

  for (var s = 0; s <= t; ++s) {
    n[s] = [0];
  }

  for (var _s2 = 0; _s2 <= o; ++_s2) {
    n[0][_s2] = 0;
  }

  for (var _s3 = 1; _s3 <= t; ++_s3) {
    for (var a = 1; a <= o; ++a) {
      n[_s3][a] = e[_s3 - 1] === r[a - 1] ? 1 + n[_s3 - 1][a - 1] : Math.max(n[_s3][a - 1], n[_s3 - 1][a]);
    }
  }

  return n[t][o];
}

function ue(e, r) {
  if (!e) return "";
  if (e = e.toUpperCase().replace(/((?=[^\u00E0-\u00FC])\W)|_/g, ""), !r) return e;
  var t = r;
  return Object.keys(t).reduce(function (o, n) {
    var s = new RegExp(n, "g");
    return o.replace(s, t[n]);
  }, e);
}

import z from "react";

var _ = function _() {
  return z.createElement("svg", {
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    className: "dropdown-search-clear-icon gray"
  }, z.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), z.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
};

import he, { useRef as Ge } from "react";
import G from "react";

var ze = function ze(_ref6) {
  var e = _ref6.checked,
      r = _ref6.option,
      t = _ref6.onClick,
      o = _ref6.disabled;
  return G.createElement("div", {
    className: "item-renderer ".concat(o && "disabled")
  }, G.createElement("input", {
    type: "checkbox",
    onChange: t,
    checked: e,
    tabIndex: -1,
    disabled: o
  }), G.createElement("span", null, r.label));
},
    fe = ze;

var Je = function Je(_ref7) {
  var _ref7$itemRenderer = _ref7.itemRenderer,
      e = _ref7$itemRenderer === void 0 ? fe : _ref7$itemRenderer,
      r = _ref7.option,
      t = _ref7.checked,
      o = _ref7.tabIndex,
      n = _ref7.disabled,
      s = _ref7.onSelectionChanged,
      a = _ref7.onClick;

  var b = Ge(),
      i = function i(d) {
    m(), d.preventDefault();
  },
      m = function m() {
    n || s(!t);
  },
      c = function c(d) {
    m(), a(d);
  };

  return P([h.ENTER, h.SPACE], i, {
    target: b
  }), he.createElement("label", {
    className: "select-item ".concat(t && "selected"),
    role: "option",
    "aria-selected": t,
    tabIndex: o,
    ref: b
  }, he.createElement(e, {
    option: r,
    checked: t,
    onClick: c,
    disabled: n
  }));
},
    L = Je;

import R from "react";

var Qe = function Qe(_ref8) {
  var e = _ref8.options,
      r = _ref8.onClick,
      t = _ref8.skipIndex;

  var _k = k(),
      o = _k.disabled,
      n = _k.value,
      s = _k.onChange,
      a = _k.ItemRenderer,
      b = function b(i, m) {
    o || s(m ? [].concat(_toConsumableArray(n), [i]) : n.filter(function (c) {
      return c.value !== i.value;
    }));
  };

  return R.createElement(R.Fragment, null, e.map(function (i, m) {
    var c = m + t;
    return R.createElement("li", {
      key: (i == null ? void 0 : i.key) || m
    }, R.createElement(L, {
      tabIndex: c,
      option: i,
      onSelectionChanged: function onSelectionChanged(d) {
        return b(i, d);
      },
      checked: !!n.find(function (d) {
        return d.value === i.value;
      }),
      onClick: function onClick(d) {
        return r(d, c);
      },
      itemRenderer: a,
      disabled: i.disabled || o
    }));
  }));
},
    ge = Qe;

var Ze = function Ze() {
  var _k2 = k(),
      e = _k2.t,
      r = _k2.onChange,
      t = _k2.options,
      o = _k2.setOptions,
      n = _k2.value,
      s = _k2.filterOptions,
      a = _k2.ItemRenderer,
      b = _k2.disabled,
      i = _k2.disableSearch,
      m = _k2.hasSelectAll,
      c = _k2.ClearIcon,
      d = _k2.debounceDuration,
      E = _k2.isCreatable,
      W = _k2.onCreateOption,
      v = xe(),
      x = xe(),
      _H = H(""),
      _H2 = _slicedToArray(_H, 2),
      C = _H2[0],
      M = _H2[1],
      _H3 = H(t),
      _H4 = _slicedToArray(_H3, 2),
      w = _H4[0],
      I = _H4[1],
      _H5 = H(""),
      _H6 = _slicedToArray(_H5, 2),
      N = _H6[0],
      D = _H6[1],
      _H7 = H(0),
      _H8 = _slicedToArray(_H7, 2),
      T = _H8[0],
      A = _H8[1],
      U = Xe(pe(function (l) {
    return D(l);
  }, d), []),
      F = ve(function () {
    var l = 0;
    return i || (l += 1), m && (l += 1), l;
  }, [i, m]),
      B = {
    label: e(C ? "selectAllFiltered" : "selectAll"),
    value: ""
  },
      $ = function $(l) {
    var p = w.filter(function (O) {
      return !O.disabled;
    }).map(function (O) {
      return O.value;
    });

    if (l) {
      var Ne = [].concat(_toConsumableArray(n.map(function (j) {
        return j.value;
      })), _toConsumableArray(p));
      return (s ? w : t).filter(function (j) {
        return Ne.includes(j.value);
      });
    }

    return n.filter(function (O) {
      return !p.includes(O.value);
    });
  },
      g = function g(l) {
    var p = $(l);
    r(p);
  },
      K = function K(l) {
    U(l.target.value), M(l.target.value), A(0);
  },
      te = function te() {
    var l;
    D(""), M(""), (l = x == null ? void 0 : x.current) == null || l.focus();
  },
      re = function re(l) {
    return A(l);
  },
      ke = function ke(l) {
    switch (l.code) {
      case h.ARROW_UP:
        oe(-1);
        break;

      case h.ARROW_DOWN:
        oe(1);
        break;

      default:
        return;
    }

    l.stopPropagation(), l.preventDefault();
  };

  P([h.ARROW_DOWN, h.ARROW_UP], ke, {
    target: v
  });

  var Ee = function Ee() {
    A(0);
  },
      Ie = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var l;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              l = {
                label: C,
                value: C,
                __isNew__: !0
              };
              _context.t0 = W;

              if (!_context.t0) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return W(C);

            case 5:
              l = _context.sent;

            case 6:
              o([l].concat(_toConsumableArray(t)));
              te();
              r([].concat(_toConsumableArray(n), [l]));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function Ie() {
      return _ref9.apply(this, arguments);
    };
  }(),
      Ae = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!s) {
                _context2.next = 6;
                break;
              }

              _context2.next = 3;
              return s(t, N);

            case 3:
              _context2.t0 = _context2.sent;
              _context2.next = 7;
              break;

            case 6:
              _context2.t0 = me(t, N);

            case 7:
              return _context2.abrupt("return", _context2.t0);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function Ae() {
      return _ref10.apply(this, arguments);
    };
  }(),
      oe = function oe(l) {
    var p = T + l;
    p = Math.max(0, p), p = Math.min(p, t.length + Math.max(F - 1, 0)), A(p);
  };

  be(function () {
    var l, p;
    (p = (l = v == null ? void 0 : v.current) == null ? void 0 : l.querySelector("[tabIndex='".concat(T, "']"))) == null || p.focus();
  }, [T]);

  var _ve = ve(function () {
    var l = w.filter(function (p) {
      return !p.disabled;
    });
    return [l.every(function (p) {
      return n.findIndex(function (O) {
        return O.value === p.value;
      }) !== -1;
    }), l.length !== 0];
  }, [w, n]),
      _ve2 = _slicedToArray(_ve, 2),
      Pe = _ve2[0],
      Me = _ve2[1];

  return be(function () {
    Ae().then(I);
  }, [N, t]), y.createElement("div", {
    className: "select-panel",
    role: "listbox",
    ref: v
  }, !i && y.createElement("div", {
    className: "search"
  }, y.createElement("input", {
    placeholder: e("search"),
    type: "text",
    "aria-describedby": e("search"),
    onChange: K,
    onFocus: Ee,
    value: C,
    ref: x,
    tabIndex: 0
  }), y.createElement("button", {
    type: "button",
    className: "search-clear-button",
    hidden: !C,
    onClick: te,
    "aria-label": e("clearSearch")
  }, c || y.createElement(_, null))), y.createElement("ul", {
    className: "options"
  }, m && Me && y.createElement(L, {
    tabIndex: F === 1 ? 0 : 1,
    checked: Pe,
    option: B,
    onSelectionChanged: g,
    onClick: function onClick() {
      return re(1);
    },
    itemRenderer: a,
    disabled: b
  }), w.length ? y.createElement(ge, {
    skipIndex: F,
    options: w,
    onClick: function onClick(l, p) {
      return re(p);
    }
  }) : E ? y.createElement("li", {
    onClick: Ie,
    className: "select-item creatable"
  }, "".concat(e("create"), " \"").concat(C, "\"")) : y.createElement("li", {
    className: "no-options"
  }, e("noOptions"))));
},
    J = Ze;

import Se from "react";

var ye = function ye(_ref11) {
  var e = _ref11.expanded;
  return Se.createElement("svg", {
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    className: "dropdown-heading-dropdown-arrow gray"
  }, Se.createElement("path", {
    d: e ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
  }));
};

import Ce from "react";

var we = function we() {
  var _k3 = k(),
      e = _k3.t,
      r = _k3.value,
      t = _k3.options,
      o = _k3.valueRenderer,
      n = r.length === 0,
      s = r.length === t.length,
      a = o && o(r, t);

  return n ? Ce.createElement("span", {
    className: "gray"
  }, a || e("selectSomeItems")) : Ce.createElement("span", null, a || (s ? e("allItemsAreSelected") : function () {
    return r.map(function (i) {
      return i.label;
    }).join(", ");
  }()));
};

import Q from "react";

var Oe = function Oe(_ref12) {
  var _ref12$size = _ref12.size,
      e = _ref12$size === void 0 ? 24 : _ref12$size;
  return Q.createElement("span", {
    style: {
      width: e,
      marginRight: "0.2rem"
    }
  }, Q.createElement("svg", {
    width: e,
    height: e,
    className: "spinner",
    viewBox: "0 0 50 50",
    style: {
      display: "inline",
      verticalAlign: "middle"
    }
  }, Q.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    className: "path"
  })));
};

var rt = function rt() {
  var _k4 = k(),
      e = _k4.t,
      r = _k4.onMenuToggle,
      t = _k4.ArrowRenderer,
      o = _k4.shouldToggleOnHover,
      n = _k4.isLoading,
      s = _k4.disabled,
      a = _k4.onChange,
      b = _k4.labelledBy,
      i = _k4.value,
      m = _k4.isOpen,
      c = _k4.defaultIsOpen,
      d = _k4.ClearSelectedIcon,
      _X = X(!0),
      _X2 = _slicedToArray(_X, 2),
      E = _X2[0],
      W = _X2[1],
      _X3 = X(c),
      _X4 = _slicedToArray(_X3, 2),
      v = _X4[0],
      x = _X4[1],
      _X5 = X(!1),
      _X6 = _slicedToArray(_X5, 2),
      C = _X6[0],
      M = _X6[1],
      w = t || ye,
      I = tt();

  ce(function () {
    r && r(v);
  }, [v]), et(function () {
    c === void 0 && typeof m == "boolean" && (W(!1), x(m));
  }, [m]);

  var N = function N(g) {
    var K;
    ["text", "button"].includes(g.target.type) && [h.SPACE, h.ENTER].includes(g.code) || (E && (g.code === h.ESCAPE ? (x(!1), (K = I == null ? void 0 : I.current) == null || K.focus()) : x(!0)), g.preventDefault());
  };

  P([h.ENTER, h.ARROW_DOWN, h.SPACE, h.ESCAPE], N, {
    target: I
  });

  var D = function D(g) {
    E && o && x(g);
  },
      T = function T() {
    return !C && M(!0);
  },
      A = function A(g) {
    !g.currentTarget.contains(g.relatedTarget) && E && (M(!1), x(!1));
  },
      U = function U() {
    return D(!0);
  },
      F = function F() {
    return D(!1);
  },
      B = function B() {
    E && x(n || s ? !1 : !v);
  },
      $ = function $(g) {
    g.stopPropagation(), a([]), E && x(!1);
  };

  return S.createElement("div", {
    tabIndex: 0,
    className: "dropdown-container",
    "aria-labelledby": b,
    "aria-expanded": v,
    "aria-readonly": !0,
    "aria-disabled": s,
    ref: I,
    onFocus: T,
    onBlur: A,
    onMouseEnter: U,
    onMouseLeave: F
  }, S.createElement("div", {
    className: "dropdown-heading",
    onClick: B
  }, S.createElement("div", {
    className: "dropdown-heading-value"
  }, S.createElement(we, null)), n && S.createElement(Oe, null), i.length > 0 && S.createElement("button", {
    type: "button",
    className: "clear-selected-button",
    onClick: $,
    disabled: s,
    "aria-label": e("clearSelected")
  }, d || S.createElement(_, null)), S.createElement(w, {
    expanded: v
  })), v && S.createElement("div", {
    className: "dropdown-content"
  }, S.createElement("div", {
    className: "panel-content"
  }, S.createElement(J, null))));
},
    Z = rt;

var ot = function ot(e) {
  return ee.createElement(ie, {
    props: e
  }, ee.createElement("div", {
    className: "rmsc ".concat(e.className || "multi-select")
  }, ee.createElement(Z, null)));
},
    nt = ot;

export { Z as Dropdown, nt as MultiSelect, L as SelectItem, J as SelectPanel };